import {
    GET_CLASSACTIVITY,
    RESET_CLASSACTIVITY
  } from "../actionTypes";


const classActivityReducer = (state = {}, action) => {
  switch (action.type) {
    case GET_CLASSACTIVITY:
      return action.payload;

    case RESET_CLASSACTIVITY:
      return null;

    default:
      return state;
  }
};

export default classActivityReducer;